import React, { lazy, useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { themeChange } from "theme-change";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";

// Importing pages
const Layout = lazy(() => import("./containers/Layout.js"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));
const LOGINPROZBUTTON = lazy(() => import("./pages/Login_proz"));
const Documentation = lazy(() => import("./pages/Documentation"));
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';



// Initializing different libraries
initializeApp();

// Check for login and initialize axios
//var token = checkAuth();

function App() {
  const [token, setToken] = useState<string>();

  const fetchToken = async () => {
    console.log("weee are fetchiiiiiiig");
    const userToken = await checkAuth();
    if (typeof userToken === "string" || typeof userToken === "undefined") {
      setToken(userToken);
    }
  };
  const stripePromise = loadStripe("pk_live_51PH00hCQ0hj09N5ru9WTxO0aQcHP77fi2dTQvwmf8ND0xAbHqysTGoJuM1rJy30r7wIM0Z3yGFDxxKnLdjPSsWqp000cEnH5mO");//loadStripe(process.env.STRIPE_PUBLIC_KEY); // Utilisez votre clé publique


  useEffect(() => {
    themeChange(false);
    fetchToken();
    // onAuthStateChanged(auth, async (user) => {
    //   console.log("hello world")
    //   if (user) {
    //     // User is signed in, see docs for a list of available properties
    //     // https://firebase.google.com/docs/reference/js/firebase.User
    //     const uid = user.uid;
    //     // ...
    //     console.log(
    //       "uidtttttttttttttttttttttttttttttttttttttttttttttttttttttt",
    //       uid,
    //       user
    //     );
    //     const userToken = await checkAuth();
    //     setToken(userToken);
    //   } else {
    //     // User is signed out
    //     // ...
    //     console.log("user is logged out");
    //   }
    // });
  }, []);
  return (
    <Elements stripe={stripePromise}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/login_proz" element={<LOGINPROZBUTTON />} />
          {/* Place new routes over this */}
          <Route path="/app/*" element={<Layout />} />

          <Route
            path="*"
            element={
              <Navigate to={token ? "/app/welcome" : "/login"} replace />
            }
          />
        </Routes>
      </Router>
    </Elements>
  );
}

export default App;
